import axios from 'axios';

import { api } from 'app/api';

/**
 * @param {{ hspId:string, usrId:string, hsptlzRsvNo:string }} params
 * @description I-11 입원 동의서 작성 전 작성 여부 확인 후 redirectURL 반환 API
 * @returns
 */
export const getHsptlzFormEntryRedirect = async (params) => {
  // return await axios.get(`/mock/hsptlz/I-11.json`);
  return await api.get(`/dfd/api/if/web/v1/hsptlz-form-sign-complete-yn`, {
    params,
  });
};

/**
 * @param {{ hspId:string, usrId:string, hsptlzRsvNo:string }} params
 * @description I-13 입원 동의서 환자 정보 화면
 * @returns
 */
export const getHsptlzFormPatientInfo = async (params) => {
  // return await axios.get(`/mock/hsptlz/I-13.json`);
  return await api.get(`/dfd/api/if/web/v1/hsptlz-form-sign-patient-info-view`, {
    params,
  });
};
